/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.exportSymbol('proto.spine.client.ColumnFilter', null, global);
goog.exportSymbol('proto.spine.client.ColumnFilter.Operator', null, global);
goog.exportSymbol('proto.spine.client.CompositeColumnFilter', null, global);
goog.exportSymbol('proto.spine.client.CompositeColumnFilter.CompositeOperator', null, global);
goog.exportSymbol('proto.spine.client.EntityFilters', null, global);
goog.exportSymbol('proto.spine.client.EntityId', null, global);
goog.exportSymbol('proto.spine.client.EntityIdFilter', null, global);
goog.exportSymbol('proto.spine.client.Target', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.EntityId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.EntityId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.EntityId.displayName = 'proto.spine.client.EntityId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.EntityId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.EntityId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.EntityId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.EntityId}
 */
proto.spine.client.EntityId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.EntityId;
  return proto.spine.client.EntityId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.EntityId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.EntityId}
 */
proto.spine.client.EntityId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.EntityId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.EntityId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.EntityId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.client.EntityId.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.client.EntityId.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.EntityId.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.EntityId.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.Target = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.spine.client.Target.oneofGroups_);
};
goog.inherits(proto.spine.client.Target, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.Target.displayName = 'proto.spine.client.Target';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.spine.client.Target.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.spine.client.Target.CriterionCase = {
  CRITERION_NOT_SET: 0,
  INCLUDE_ALL: 2,
  FILTERS: 3
};

/**
 * @return {proto.spine.client.Target.CriterionCase}
 */
proto.spine.client.Target.prototype.getCriterionCase = function() {
  return /** @type {proto.spine.client.Target.CriterionCase} */(jspb.Message.computeOneofCase(this, proto.spine.client.Target.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.Target.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.Target.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.Target} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Target.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    includeAll: jspb.Message.getFieldWithDefault(msg, 2, false),
    filters: (f = msg.getFilters()) && proto.spine.client.EntityFilters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.Target}
 */
proto.spine.client.Target.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.Target;
  return proto.spine.client.Target.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.Target} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.Target}
 */
proto.spine.client.Target.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAll(value);
      break;
    case 3:
      var value = new proto.spine.client.EntityFilters;
      reader.readMessage(value,proto.spine.client.EntityFilters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.Target.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.Target.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.Target} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.Target.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.spine.client.EntityFilters.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.spine.client.Target.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.client.Target.prototype.setType = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_all = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.spine.client.Target.prototype.getIncludeAll = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.spine.client.Target.prototype.setIncludeAll = function(value) {
  jspb.Message.setOneofField(this, 2, proto.spine.client.Target.oneofGroups_[0], value);
};


proto.spine.client.Target.prototype.clearIncludeAll = function() {
  jspb.Message.setOneofField(this, 2, proto.spine.client.Target.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Target.prototype.hasIncludeAll = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EntityFilters filters = 3;
 * @return {?proto.spine.client.EntityFilters}
 */
proto.spine.client.Target.prototype.getFilters = function() {
  return /** @type{?proto.spine.client.EntityFilters} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.EntityFilters, 3));
};


/** @param {?proto.spine.client.EntityFilters|undefined} value */
proto.spine.client.Target.prototype.setFilters = function(value) {
  jspb.Message.setOneofWrapperField(this, 3, proto.spine.client.Target.oneofGroups_[0], value);
};


proto.spine.client.Target.prototype.clearFilters = function() {
  this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.Target.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.EntityFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.client.EntityFilters.repeatedFields_, null);
};
goog.inherits(proto.spine.client.EntityFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.EntityFilters.displayName = 'proto.spine.client.EntityFilters';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.client.EntityFilters.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.EntityFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.EntityFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.EntityFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityFilters.toObject = function(includeInstance, msg) {
  var f, obj = {
    idFilter: (f = msg.getIdFilter()) && proto.spine.client.EntityIdFilter.toObject(includeInstance, f),
    filterList: jspb.Message.toObjectList(msg.getFilterList(),
    proto.spine.client.CompositeColumnFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.EntityFilters}
 */
proto.spine.client.EntityFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.EntityFilters;
  return proto.spine.client.EntityFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.EntityFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.EntityFilters}
 */
proto.spine.client.EntityFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.EntityIdFilter;
      reader.readMessage(value,proto.spine.client.EntityIdFilter.deserializeBinaryFromReader);
      msg.setIdFilter(value);
      break;
    case 2:
      var value = new proto.spine.client.CompositeColumnFilter;
      reader.readMessage(value,proto.spine.client.CompositeColumnFilter.deserializeBinaryFromReader);
      msg.addFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.EntityFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.EntityFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.EntityFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.client.EntityIdFilter.serializeBinaryToWriter
    );
  }
  f = message.getFilterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.spine.client.CompositeColumnFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityIdFilter id_filter = 1;
 * @return {?proto.spine.client.EntityIdFilter}
 */
proto.spine.client.EntityFilters.prototype.getIdFilter = function() {
  return /** @type{?proto.spine.client.EntityIdFilter} */ (
    jspb.Message.getWrapperField(this, proto.spine.client.EntityIdFilter, 1));
};


/** @param {?proto.spine.client.EntityIdFilter|undefined} value */
proto.spine.client.EntityFilters.prototype.setIdFilter = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.client.EntityFilters.prototype.clearIdFilter = function() {
  this.setIdFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.EntityFilters.prototype.hasIdFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated CompositeColumnFilter filter = 2;
 * @return {!Array<!proto.spine.client.CompositeColumnFilter>}
 */
proto.spine.client.EntityFilters.prototype.getFilterList = function() {
  return /** @type{!Array<!proto.spine.client.CompositeColumnFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.spine.client.CompositeColumnFilter, 2));
};


/** @param {!Array<!proto.spine.client.CompositeColumnFilter>} value */
proto.spine.client.EntityFilters.prototype.setFilterList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.client.CompositeColumnFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.client.CompositeColumnFilter}
 */
proto.spine.client.EntityFilters.prototype.addFilter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.client.CompositeColumnFilter, opt_index);
};


proto.spine.client.EntityFilters.prototype.clearFilterList = function() {
  this.setFilterList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.CompositeColumnFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.client.CompositeColumnFilter.repeatedFields_, null);
};
goog.inherits(proto.spine.client.CompositeColumnFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.CompositeColumnFilter.displayName = 'proto.spine.client.CompositeColumnFilter';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.client.CompositeColumnFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.CompositeColumnFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.CompositeColumnFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.CompositeColumnFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.CompositeColumnFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    filterList: jspb.Message.toObjectList(msg.getFilterList(),
    proto.spine.client.ColumnFilter.toObject, includeInstance),
    operator: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.CompositeColumnFilter}
 */
proto.spine.client.CompositeColumnFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.CompositeColumnFilter;
  return proto.spine.client.CompositeColumnFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.CompositeColumnFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.CompositeColumnFilter}
 */
proto.spine.client.CompositeColumnFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.ColumnFilter;
      reader.readMessage(value,proto.spine.client.ColumnFilter.deserializeBinaryFromReader);
      msg.addFilter(value);
      break;
    case 2:
      var value = /** @type {!proto.spine.client.CompositeColumnFilter.CompositeOperator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.CompositeColumnFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.CompositeColumnFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.CompositeColumnFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.CompositeColumnFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.spine.client.ColumnFilter.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.spine.client.CompositeColumnFilter.CompositeOperator = {
  CCF_CO_UNDEFINED: 0,
  ALL: 1,
  EITHER: 2
};

/**
 * repeated ColumnFilter filter = 1;
 * @return {!Array<!proto.spine.client.ColumnFilter>}
 */
proto.spine.client.CompositeColumnFilter.prototype.getFilterList = function() {
  return /** @type{!Array<!proto.spine.client.ColumnFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.spine.client.ColumnFilter, 1));
};


/** @param {!Array<!proto.spine.client.ColumnFilter>} value */
proto.spine.client.CompositeColumnFilter.prototype.setFilterList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.spine.client.ColumnFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.client.ColumnFilter}
 */
proto.spine.client.CompositeColumnFilter.prototype.addFilter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.spine.client.ColumnFilter, opt_index);
};


proto.spine.client.CompositeColumnFilter.prototype.clearFilterList = function() {
  this.setFilterList([]);
};


/**
 * optional CompositeOperator operator = 2;
 * @return {!proto.spine.client.CompositeColumnFilter.CompositeOperator}
 */
proto.spine.client.CompositeColumnFilter.prototype.getOperator = function() {
  return /** @type {!proto.spine.client.CompositeColumnFilter.CompositeOperator} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.spine.client.CompositeColumnFilter.CompositeOperator} value */
proto.spine.client.CompositeColumnFilter.prototype.setOperator = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.ColumnFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.client.ColumnFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.ColumnFilter.displayName = 'proto.spine.client.ColumnFilter';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.ColumnFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.ColumnFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.ColumnFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.ColumnFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    columnName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: (f = msg.getValue()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    operator: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.ColumnFilter}
 */
proto.spine.client.ColumnFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.ColumnFilter;
  return proto.spine.client.ColumnFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.ColumnFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.ColumnFilter}
 */
proto.spine.client.ColumnFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnName(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto.spine.client.ColumnFilter.Operator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.ColumnFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.ColumnFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.ColumnFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.ColumnFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.spine.client.ColumnFilter.Operator = {
  CFO_UNDEFINED: 0,
  EQUAL: 1,
  GREATER_THAN: 2,
  LESS_THAN: 4,
  GREATER_OR_EQUAL: 5,
  LESS_OR_EQUAL: 6
};

/**
 * optional string column_name = 1;
 * @return {string}
 */
proto.spine.client.ColumnFilter.prototype.getColumnName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.client.ColumnFilter.prototype.setColumnName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Any value = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.client.ColumnFilter.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.client.ColumnFilter.prototype.setValue = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.client.ColumnFilter.prototype.clearValue = function() {
  this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.client.ColumnFilter.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Operator operator = 3;
 * @return {!proto.spine.client.ColumnFilter.Operator}
 */
proto.spine.client.ColumnFilter.prototype.getOperator = function() {
  return /** @type {!proto.spine.client.ColumnFilter.Operator} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.spine.client.ColumnFilter.Operator} value */
proto.spine.client.ColumnFilter.prototype.setOperator = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.client.EntityIdFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.client.EntityIdFilter.repeatedFields_, null);
};
goog.inherits(proto.spine.client.EntityIdFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.client.EntityIdFilter.displayName = 'proto.spine.client.EntityIdFilter';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.client.EntityIdFilter.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.client.EntityIdFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.client.EntityIdFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.client.EntityIdFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityIdFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: jspb.Message.toObjectList(msg.getIdsList(),
    proto.spine.client.EntityId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.client.EntityIdFilter}
 */
proto.spine.client.EntityIdFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.client.EntityIdFilter;
  return proto.spine.client.EntityIdFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.client.EntityIdFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.client.EntityIdFilter}
 */
proto.spine.client.EntityIdFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.client.EntityId;
      reader.readMessage(value,proto.spine.client.EntityId.deserializeBinaryFromReader);
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.client.EntityIdFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.client.EntityIdFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.client.EntityIdFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.client.EntityIdFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.spine.client.EntityId.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EntityId ids = 1;
 * @return {!Array<!proto.spine.client.EntityId>}
 */
proto.spine.client.EntityIdFilter.prototype.getIdsList = function() {
  return /** @type{!Array<!proto.spine.client.EntityId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.spine.client.EntityId, 1));
};


/** @param {!Array<!proto.spine.client.EntityId>} value */
proto.spine.client.EntityIdFilter.prototype.setIdsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.spine.client.EntityId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.client.EntityId}
 */
proto.spine.client.EntityIdFilter.prototype.addIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.spine.client.EntityId, opt_index);
};


proto.spine.client.EntityIdFilter.prototype.clearIdsList = function() {
  this.setIdsList([]);
};


goog.object.extend(exports, proto.spine.client);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.client.EntityId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.EntityId.fromObject(jsObject);
};

proto.spine.client.EntityId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.EntityId();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.id);
      msg.setId(value);
    }
  }
  return msg;
};

proto.spine.client.Target.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.Target.fromObject(jsObject);
};

proto.spine.client.Target.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.Target();
  
  if (obj.type !== undefined) {
    if (obj.type !== null) {
      let value = obj.type;
      msg.setType(value);
    }
  }
  
  if (obj.includeAll !== undefined) {
    if (obj.includeAll !== null) {
      let value = obj.includeAll;
      msg.setIncludeAll(value);
    }
  }
  
  if (obj.filters !== undefined) {
    if (obj.filters === null) {
      msg.setFilters(null);
    } else {
      let value = proto.spine.client.EntityFilters.fromObject(obj.filters);
      msg.setFilters(value);
    }
  }
  return msg;
};

proto.spine.client.EntityFilters.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.EntityFilters.fromObject(jsObject);
};

proto.spine.client.EntityFilters.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.EntityFilters();
  
  if (obj.idFilter !== undefined) {
    if (obj.idFilter === null) {
      msg.setIdFilter(null);
    } else {
      let value = proto.spine.client.EntityIdFilter.fromObject(obj.idFilter);
      msg.setIdFilter(value);
    }
  }
  
  if (obj.filter !== undefined && obj.filter !== null) {
    obj.filter.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addFilter(null);
        } else {
          let value = proto.spine.client.CompositeColumnFilter.fromObject(listItem);
          msg.addFilter(value);
        }
      }
    );
  }
  return msg;
};

proto.spine.client.CompositeColumnFilter.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.CompositeColumnFilter.fromObject(jsObject);
};

proto.spine.client.CompositeColumnFilter.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.CompositeColumnFilter();
  
  if (obj.filter !== undefined && obj.filter !== null) {
    obj.filter.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addFilter(null);
        } else {
          let value = proto.spine.client.ColumnFilter.fromObject(listItem);
          msg.addFilter(value);
        }
      }
    );
  }
  
  if (obj.operator !== undefined) {
    if (obj.operator !== null) {
      let value = proto.spine.client.CompositeColumnFilter.CompositeOperator[obj.operator];
      msg.setOperator(value);
    }
  }
  return msg;
};

proto.spine.client.ColumnFilter.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.ColumnFilter.fromObject(jsObject);
};

proto.spine.client.ColumnFilter.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.ColumnFilter();
  
  if (obj.columnName !== undefined) {
    if (obj.columnName !== null) {
      let value = obj.columnName;
      msg.setColumnName(value);
    }
  }
  
  if (obj.value !== undefined) {
    if (obj.value === null) {
      msg.setValue(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.value);
      msg.setValue(value);
    }
  }
  
  if (obj.operator !== undefined) {
    if (obj.operator !== null) {
      let value = proto.spine.client.ColumnFilter.Operator[obj.operator];
      msg.setOperator(value);
    }
  }
  return msg;
};

proto.spine.client.EntityIdFilter.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.client.EntityIdFilter.fromObject(jsObject);
};

proto.spine.client.EntityIdFilter.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.client.EntityIdFilter();
  
  if (obj.ids !== undefined && obj.ids !== null) {
    obj.ids.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addIds(null);
        } else {
          let value = proto.spine.client.EntityId.fromObject(listItem);
          msg.addIds(value);
        }
      }
    );
  }
  return msg;
};
